import { createAction } from 'redux-actions';

export const getFavoriteCompaniesRequested = createAction('GET_FAVORITE_COMPANIES_REQUEST');
export const getFavoriteCompaniesReceived = createAction('GET_FAVORITE_COMPANIES_RECEIVED');
export const getFavoriteCompaniesReceiveFailure = createAction('GET_FAVORITE_COMPANIES_RECEIVE_FAILURE');
export const getFavoriteCompaniesClear = createAction('GET_FAVORITE_COMPANIES_CLEAR');

export const updateFavoriteCompaniesRequested = createAction('UPDATE_FAVORITE_COMPANIES_REQUEST');
export const updateFavoriteCompaniesReceived = createAction('UPDATE_FAVORITE_COMPANIES_RECEIVED');
export const updateFavoriteCompaniesReceiveFailure = createAction('UPDATE_FAVORITE_COMPANIES_RECEIVE_FAILURE');
export const updateFavoriteCompaniesClear = createAction('UPDATE_FAVORITE_COMPANIES_CLEAR');
